import CookiesJS from 'cookies-js';

export function initLogin($, authClient) {
    $('form.login-form .action__login').on('click', async function () {
        try {
            const params = {
                password: $('#password').val(),
            };
            if ($('#email').val()) params.email = $('#email').val();
            const result = await authClient.login(params);
            console.log(result);
            if (!result.token) {
                throw new Error('Auth failed. Invalid credentials.');
            }
            if (!result.user || !result.user.roles || !result.user.roles.length || !result.user.roles.includes('admin')) {
                throw new Error('Auth failed. Not an admin');
            }
            CookiesJS.set('auth_token', result.token, { expires: Infinity });
            document.location.href='/';
            return;
        } catch(e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
